import { IonButton } from '@ionic/react';
import React from 'react';

import { Dentist } from '@/data/Dentists';

import './Selection.css';

interface SelectionProps {
  options: any[];
  getLabel: (option: any) => string | React.ReactNode;
  onClick: React.Dispatch<React.SetStateAction<any | null>>;
  isSelected: (option: any) => boolean;
}

const Selection: React.FC<SelectionProps> = ({
  options,
  getLabel,
  onClick,
  isSelected
}) => {
  if (options.length === 0) return null;

  const handleClick = (option: Dentist | string, selected: boolean) => {
    if (selected) {
      onClick(null);
    } else {
      onClick(option);
    }
  };

  return (
    <div className="selection">
      {options.map((option) => {
        const selected = isSelected(option);
        return (
          <IonButton
            key={option.id || option}
            onClick={() => handleClick(option, selected)}
            expand="block"
            fill={selected ? 'outline' : 'solid'}
            size="default"
            className={selected ? 'selected' : ''}
          >
            {getLabel(option)}
          </IonButton>
        );
      })}
    </div>
  );
};

export default Selection;
